import { CircularProgress, Divider, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { loadComissions } from "../data/API";


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchField from "../mui/SearchField";



function BasicTable({ list }) {
    console.log(list);
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ fontWeight: 'bold' }}>ID</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Amount</TableCell>

                        <TableCell align="left" style={{ fontWeight: 'bold' }} >Kitchen ID</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Order ID</TableCell>

                        <TableCell align="left" style={{ fontWeight: 'bold' }}>User ID</TableCell>


                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((row) => (
                        <TableRow
                            key={row.name}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.id}
                            </TableCell>
                            <TableCell align="left" style={{ color: 'green' }}>{row.amount}RM</TableCell>
                            <TableCell align="left">{row.kitchen_id}</TableCell>
                            <TableCell align="left">{row.order_id}</TableCell>

                            <TableCell align="left">{row.user_id}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default function Comission() {


    const [loading, setLoading] = useState(true);
    const [comissions, setComissions] = useState();

    function getComissions() {
        loadComissions((err, data) => {
            if (err) {

                setLoading(false);
                console.log(err);
            } else {

                setLoading(false);
                setComissions(data);
            }
        })
    }


    useEffect(() => {
        getComissions()
    }, [])


    const [query, setQuery] = useState("");


    function getTotalComissions() {
        var t = 0;
        comissions.forEach(element => {
            t += parseFloat(element.amount);
        });
        return t.toFixed(4);
    }

    return (
        <div className="w-full flex  flex-col  min-h-64  justify-center items-center">
            {loading && <div className="p-2  rounded-full border-[2px] h-20 w-20 flex justify-center items-center  "><CircularProgress size={50} /></div>}
            {comissions && <div className="rounded-xl flex-row flex gap-10 w-full mt-5 mb-5 self-start p-4 shadow-sm bg-white ">
                <div>
                    <strong className="text-[20px]">Total Comissions</strong>

                    <br />


                    <span className=" text-[30px] text-green-600 font-bold">{getTotalComissions()} RM</span>
                </div>
                <div className="w-1/2">

                    <SearchField w={700} setQuery={setQuery} query={query} placeholder={"Search with Kitchen Id,User ID, Order ID"} />

             
                </div>

            </div>}

            {comissions && <BasicTable list={comissions.filter((e)=>e.kitchen_id.toString().includes(query)||e.user_id.toString().includes(query)||e.order_id.toString().includes(query))} />}
        </div>
    );

}